module.exports = __webpack_public_path__ + "img/portalnobres.512763dd.png";